/**
 * Copyright (c) ACT, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

import { ConfirmDialog } from './ConfirmDialog';

export * from './ConfirmDialog';

export default ConfirmDialog;
